import { NetworkType, NotificationService, RecipientTypes } from '@capsicum/common';
import { Card, RecipientForm, type RecipientFormShape, Snackbar, useRouter } from '@capsicum/common-web';
import { useNCWRecipientCreate } from '@capsicum/features/nc-wallet/shared';
import { useWalletWithdrawAddRecipientMutation } from '@capsicum/features/wallet/shared';
import styled from 'styled-components';

export const NCWCreateRecipient = () => {
	const { back } = useRouter();

	const { isPending, mutateAsync: createRecipient } = useWalletWithdrawAddRecipientMutation();

	const { intlText } = useNCWRecipientCreate();

	const onFormSubmission = (data: RecipientFormShape) => {
		createRecipient(
			{
				blockchainAddress: data.address.trim(),
				label: data.recipientName.trim(),
				network: NetworkType.CC2,
				type: data.type,
				walletOrExchangeName: data.exchange
			},
			{
				onSuccess: () => {
					back();
					NotificationService.addNotification({
						component: (
							<Snackbar
								description={intlText.notificationSuccess}
								testID="ncWallet-recipientCreate-successSnackbar"
								variant="success"
							/>
						)
					});
				}
			}
		);
	};

	return (
		<S.Container>
			<S.Title>{intlText.title}</S.Title>
			<S.CreateRecipientCard>
				<RecipientForm
					alertText={intlText.alert}
					defaultValues={{
						address: '',
						exchange: '',
						recipientName: '',
						type: RecipientTypes.PERSONAL
					}}
					isSaving={isPending}
					networkType={NetworkType.CC2}
					secondaryButtonLabel={intlText.cancel}
					submitButtonLabel={intlText.createButtonLabel}
					onSecondaryClick={() => back()}
					onSubmitForm={onFormSubmission}
				/>
			</S.CreateRecipientCard>
		</S.Container>
	);
};

namespace S {
	export const Container = styled.div`
		display: flex;
		flex-direction: column;
		width: 100%;
		padding: ${({ theme }) => theme.spacings.medium};
	`;

	export const CreateRecipientCard = styled(Card)`
		display: flex;
		flex-direction: column;
		padding: ${({ theme }) => theme.spacings.medium};
		max-width: 100%;
	`;
	export const Title = styled.p`
		${({ theme }) => theme.fonts.headings.title5};
		color: ${({ theme }) => theme.colors.text.main.enabled};
		margin: 0 0 ${({ theme }) => theme.spacings.medium};
	`;
}
